:root {
  --text-dark: #160004;
  --text-light: #ffffff;
  --footer-bg: #b1b1b1;
  --page-bg: #f5f5f5;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Red Rose', 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  background: var(--page-bg);
  color: var(--text-dark);
}

a {
  color: inherit;
  text-decoration: none;
}

.collections-page {
  min-height: 100vh;
}

.collections-hero {
  background: url(../../../assets/images/pages-products-collections-collections-hero.png)
    center / cover no-repeat;
}

.collections-hero__overlay {
  min-height: clamp(260px, 48vw, 560px);
  padding: 1.25rem 1rem 3rem;
  background: rgba(22, 0, 4, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.site-nav {
  width: min(1740px, 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem 1.2rem;
}

.site-nav__link {
  color: var(--text-light);
  font-size: 0.9rem;
  letter-spacing: 0.03em;
}

.site-nav__link--active {
  font-weight: 600;
}

.site-nav__logo {
  width: 2.2rem;
  height: 2.2rem;
  margin-left: 0.5rem;
}

.collections-hero__title {
  font-family: Red Rose-Medium;
  margin: 0;
  text-align: center;
  color: var(--text-light);
  font-size: clamp(2rem, 4.5vw, 3.3rem);
  transform: translateY(3vh);
  line-height: 1.08;
  width: min(92%, 1500px);
  z-index: 1;
  letter-spacing: 0.3rem;
  text-transform: uppercase;
}

.collections-main {
  padding: clamp(2.2rem, 7vw, 7.5rem) 0;
}

.collections-grid-section {
  width: min(1800px, calc(100% - 1.5rem));
  margin: 0 auto;
}

.collections-grid-section__title {
  font-family: Red Rose-Regular;
  padding: 3% 0px;
  text-align: center;
  font-size: clamp(1.6rem, 4.8vw, 5rem);
  line-height: 1.05;
  font-weight: 400;
}

.collections-grid {
  margin-top: clamp(1.5rem, 4vw, 5rem);
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}

.color-card {
  position: relative;
  width: 100%;
  align-self: start;
  aspect-ratio: 1 / 1;
  padding: clamp(1rem, 2.2vw, 4rem);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-size: cover;
  background-position: center;
  color: var(--text-light);
  overflow: hidden;

  &[data-motion='card'] {
    /* Collections product cards: slide up only, no zoom-in feel. */
    --motion-distance: 96px;
    --motion-duration: 760ms;
    --motion-scale-from: 1;
    --motion-tilt-from: 0deg;
  }
}

.color-card::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.03));
}

.color-card__name,
.color-card__action {
  position: relative;
  z-index: 1;
}

.color-card__name {
  font-family: Red Rose-Medium;
  margin: 0;
  font-size: clamp(1.05rem, 2.5vw, 3.5rem);
  line-height: 1.1;
  font-weight: 500;
  max-width: 80%;
}

.color-card__action {
  font-family: Red Rose-Regular;
  margin-top: clamp(0.9rem, 2vw, 2.8rem);
  align-self: flex-start;
  border: 1px solid rgba(255, 255, 255, 0.96);
  border-radius: 0.35rem;
  padding: 0.5rem 1rem;
  font-size: clamp(0.8rem, 1.1vw, 1.35rem);
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.site-footer {
  margin-top: clamp(2.5rem, 6vw, 11rem);
  background: var(--footer-bg);
  padding: clamp(1.5rem, 3.8vw, 8rem) 1rem 1rem;
  overflow: hidden;
}

.site-footer__container {
  width: min(1800px, 100%);
  margin: 0 auto;
}

.site-footer__top {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.site-footer__follow-title {
  margin: 0;
  font-size: clamp(1.25rem, 3vw, 3rem);
  font-weight: 500;
  text-transform: uppercase;
}

.site-footer__quick-links {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
  font-size: clamp(0.85rem, 1.6vw, 1.2rem);
}

.site-footer__content {
  margin-top: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.site-footer__socials {
  display: flex;
  gap: 0.75rem;
}

.site-footer__social-icon {
  width: 2rem;
  height: 2rem;
}

.site-footer__contact {
  margin: 0;
  font-style: normal;
  font-size: clamp(0.85rem, 1.4vw, 1.1rem);
  line-height: 1.5;
}

.site-footer__contact p {
  margin: 0.3rem 0;
}

.site-footer__brand-row {
  width: min(1800px, 100%);
  margin: clamp(1.5rem, 4vw, 4.5rem) auto 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.site-footer__brand {
  color: rgba(255, 255, 255, 0.68);
  font-size: clamp(3.1rem, 16vw, 31rem);
  line-height: 0.9;
  white-space: nowrap;
  user-select: none;
}

.site-footer__copyright {
  color: #6f6f6f;
  font-size: clamp(0.72rem, 1.4vw, 1.1rem);
}

@media (min-width: 768px) {
  .collections-hero__overlay {
    padding: 2rem 2rem 4rem;
  }

  .site-nav {
    justify-content: flex-start;
    gap: 1rem 2.5rem;
  }

  .site-nav__logo {
    margin-left: auto;
  }

  .collections-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .site-footer__top {
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
  }

  .site-footer__quick-links {
    justify-content: flex-end;
    gap: 1rem 1.8rem;
  }

  .site-footer__content {
    margin-top: 1.75rem;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  .site-footer__brand-row {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1.2rem;
  }
}

@media (min-width: 1024px) {
  .collections-grid {
    gap: 1.25rem;
  }

  .site-nav__link {
    font-size: 1.1rem;
  }
}
